import { Component } from '@angular/core';
import { BankBaseTabPageComponent } from '../bank-base-tab-page.component';

@Component({
  selector: 'bank-recon-setup',
  standalone: true,
  imports: [],
  templateUrl: './bank-recon-setup.component.html',
  styleUrl: './bank-recon-setup.component.less'
})
export class BankReconSetupComponent extends BankBaseTabPageComponent {
}
